import { render, staticRenderFns } from "./MoleculeSidebarAccordionResults.vue?vue&type=template&id=60432d04&scoped=true&"
import script from "./MoleculeSidebarAccordionResults.vue?vue&type=script&lang=js&"
export * from "./MoleculeSidebarAccordionResults.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSidebarAccordionResults.vue?vue&type=style&index=0&id=60432d04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60432d04",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
